import React from "react";
import {useSelector} from "react-redux";
import {bbFindEntityWithinPortfolioOrSelf} from "../../../util/bbHelpers";
import DataTile from "../metrics/DataTile";
import BBIconSocialTestIcon from "../../../assets/bbCustomIcons/BBIconSocialTestIcon";

const TileBRSocialAllTimeNumTests = (props) => {

    // const {customerId} = props;

    const techDataVarName = "tests"

    /**************************/
    /*Setup State and Dispatch*/
    /**************************/
    const {customers, customerInView} = useSelector(({customer}) => customer);
    const {portfolios, entityInView, loadingCycleSocial} = useSelector(({breachrisk}) => breachrisk);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const lastCycleId = myEntity && myEntity.settings && myEntity.settings.last_cycle_id;

    const social = myEntity
        && myEntity.cycles
        && lastCycleId
        && myEntity.cycles[lastCycleId]
        // && !loadingCycleSocial[lastCycleId]
        && myEntity.cycles[lastCycleId].social;


    const valueFunction = (stateData) => {

        return social
        && social.allTimeTotals
        && social.allTimeTotals[techDataVarName]
            ?  social.allTimeTotals[techDataVarName]
            : 0;
    }


    return (
        <DataTile
            // color = {colorFunction()}
            // colorBgFunction={colorFunction}
            subTitle="Spearphishing Emails Sent"
            tipText={`The total number of spearphishing emails sent.`}
            icon={<BBIconSocialTestIcon style={{fontSize: "70px"}}/>}
            stateName="breachrisk"
            stateElement="portfolios"
            //useDeepDataStore
            // dontFetch
            forceLoadingState = {myEntity && myEntity.settings && myEntity.settings.last_cycle_id && social ? false : true}
            valueFunction={valueFunction}
            // ribbonFunction={null}
            // requiresModule={"monitor"}
        />
    )

}

export default TileBRSocialAllTimeNumTests;
